import React, { useEffect, useState } from "react";
import {
  useSearchParams,
	Link 
} from "react-router-dom";
import s from './students.module.css';
import {getData, postData} from '../middleware/apiMiddleware';
import { useNavigate, useParams } from "react-router-dom";
import {GreenButton, BlueButton, RedButton} from '../components/MyButton';
import { getGeneralStorage, setGeneralStorage} from '../middleware/dataStorage';
import {unsecuredCopyToClipboard} from '../middleware/clipboardService';
import UserUpdate from '../components/UserUpdate';
import MyTooltip from '../components/Utilities/MyTooltip';
import MyPressButton, {MyGreenPressButton} from '../components/Utilities/MyPressButton';

export default function Students() {
	const [searchModeEnable, setSearchModeEnable] = useState(true);
	const [updateModeEnable, setUpdateModeEnable] = useState(false);
	const [addCoinsModeEnable, setAddCoinsModeEnable] = useState(false);
	const [addToEhlaOrgModeEnable, setAddToEhlaOrgModeEnable] = useState(false);
		
	return (<div>
		<div className="generalTitleHolder">
			<div>Users</div>
			
			<MyTooltip msg={"&lt;page&gt;" +
											"students.js<br/><br/>" +
											"&lt;components&gt;<br/>" +
											"UserUpdate.js<br/>"} /> 
		</div>
		
		
		<div className={s.paramHolder} style={{display:"flex", alignItems:"center", gap:"10px", padding:"5px", flexWrap:"wrap"}}>
			<div className={s.nonClickableTitle} >Mode:</div>
			<MyPressButton isPressed={searchModeEnable} clickedAction={()=>{setSearchModeEnable(p=>!p)}} bText="Search"/>
			<MyPressButton isPressed={updateModeEnable} clickedAction={()=>{setUpdateModeEnable(p=>!p)}} bText="Update"/>
			<MyPressButton isPressed={addCoinsModeEnable} clickedAction={()=>{setAddCoinsModeEnable(p=>!p)}} bText="Add Coins"/>
			<MyPressButton isPressed={addToEhlaOrgModeEnable} clickedAction={()=>{setAddToEhlaOrgModeEnable(p=>!p)}} bText="Add to EHLA Organization"/>
		</div>
		
		{ (searchModeEnable) && (<SearchUsers addCoinsModeEnable={addCoinsModeEnable} addToEhlaOrgModeEnable={addToEhlaOrgModeEnable}/>) }
		{ (updateModeEnable) && (<UserUpdate />) }
	</div>);
}

const SearchUsers = ({addCoinsModeEnable, addToEhlaOrgModeEnable}) => {	
	const navigate = useNavigate();
		
	const [searchData, setSearchData] = useState("");
	const [keyData, setKeyData] = useState(keyDefaultData);
	const [users, setUsers] = useState([]);
	
	const [hoverId, setHoverId] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const [isCreateLoading, setIsCreateLoading] = useState(false);
	const [createUserGroup, setCreateUserGroup] = useState(5);
	
	const [password, setPassword] = useState("12345678");
	
	const addUserToOrganization = async (indexD, userId, oId) => {
		let obj = { userId, oId, oGroup:"student"}
		
		postData("studentApi/addUserToOrganization", obj, navigate); 
		
		setUsers((prev) => {
			prev[indexD].oId = 125
			return [...prev];
		})
	}
	const enableToken = async (accessToken) => {
		let obj = { accessToken }
		postData("user/enableToken", obj, navigate); 
		
	}
	
  const isValidDate = (dateString) => {
    // Regular expression to check the date format
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;

    // Check if the input matches the regular expression
    if (!dateRegex.test(dateString)) {
      return false;
    }

    // Parse the date components
    const [year, month, day] = dateString.split('-');
    const parsedYear = parseInt(year, 10);
    const parsedMonth = parseInt(month, 10);
    const parsedDay = parseInt(day, 10);

    // Check if the date is valid
    if (
      isNaN(parsedYear) ||
      isNaN(parsedMonth) ||
      isNaN(parsedDay) ||
      parsedMonth < 1 ||
      parsedMonth > 12 ||
      parsedDay < 1 ||
      parsedDay > new Date(parsedYear, parsedMonth, 0).getDate()
    ) {
      return false;
    }

    return true;
  };
	
	const searchUser = async () => {		
		if (!(searchData && !isLoading)) {
			return;
		}
		setIsCreatable(false);
		setUsers([]);
		setIsLoading(true);
		let obj = { searchData, searchKey:[], isExactMatch:false  }
		
		for (let kd of keyData) {
			if (kd.isEnable) {
				obj.searchKey.push(kd.searchKey);
			}
		}
		
		let res = await postData("studentApi/search", obj, navigate); 
		setUsers(res.data);
		if (res.data.length == 0) {
			setIsCreatable(true);
		}
		setIsLoading(false);
	}
	
	const searchUserExactMatch = async () => {		
		if (!(searchData && !isLoading)) {
			return;
		}
		setIsCreatable(false);
		setUsers([]);
		setIsLoading(true);
		let obj = { searchData, searchKey:[], isExactMatch:true }
		
		for (let kd of keyData) {
			if (kd.isEnable) {
				obj.searchKey.push(kd.searchKey);
			}
		}
		
		let res = await postData("studentApi/search", obj, navigate); 
		setUsers(res.data);
		if (res.data.length == 0) {
			setIsCreatable(true);
		}
		setIsLoading(false);
	}
	
	const updateUser = async (index, id, nickname, phone, email, coins, vipExpiryDate) => {
		let obj = { id, nickname, phone, email }
		
		await postData("studentApi/updateUser", obj, navigate); 
		
		if (Number.isInteger(parseInt(coins))) {
			obj = {id, coins}
			postData("studentApi/updateVipCoins", obj, navigate); 
		}
		
		if (/^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/.test(vipExpiryDate)) {
			obj = {id, vipExpiryDate}
			postData("studentApi/updateVipExpiryDate", obj, navigate); 
		}
		
		
		users[index].canUpdate = false;
		setUsers([...users]);
	}
	
	const [isCreatable, setIsCreatable] = useState(false);
	
	const createUser = async () => {		
		if (!(password.length > 0 && !isCreateLoading)) {
			return;
		}
	
		setIsCreateLoading(true);
		let obj = { username:searchData, password, userGroup:createUserGroup }
	
		let res = await postData("studentApi/createUser", obj, navigate); 
		setUsers(res.data);
			
		setIsCreatable(false);
		setIsCreateLoading(false);
	}
	return (<>
		<div className={s.paramHolder}>
			<div style={{display:"flex", borderBottom:"1px solid #4b3f1b"}}>
				<div style={{display:"flex", padding:"10px 0 0 0"}}>
					<div className={s.nonClickableTitle}>
						<span>Search</span>
					</div>
					<div style={{fontWeight:"bold"}}>:</div>		
				</div>
				<div className={s.itemHolder}>
					<input value={searchData} onChange={(e)=>{
						setSearchData(e.target.value);
						setIsCreatable(false);
					}} />
					<div className={(searchData && !isLoading) ? s.btnActive : s.btnInactive} onClick={searchUser}>
						{(!isLoading) ? "search" : "loading..."}
					</div>
					<div className={(searchData && !isLoading) ? s.btnActive : s.btnInactive} onClick={searchUserExactMatch}>
						{(!isLoading) ? "Exact Match Search" : "loading..."}
					</div>
				</div>
			</div>
			
			{
				(isCreatable) && (<div style={{display:"flex", borderBottom:"1px solid #4b3f1b"}}>
					<div style={{display:"flex", padding:"10px 0 0 0"}}>
						<div className={s.nonClickableTitle}>
							<span>Password</span>
						</div>
						<div style={{fontWeight:"bold"}}>:</div>		
					</div>
					<div className={s.itemHolder}>
						<input value={password} onChange={(e)=>{
							setPassword(e.target.value);
						}} />
						
						{
							(createUserGroup == 3) && (<BlueButton isEnabled={true} clickedAction={()=>setCreateUserGroup(5)} bText={"Teacher"} />)
						}
						{
							(createUserGroup == 5) && (<GreenButton isEnabled={true} clickedAction={()=>setCreateUserGroup(3)} bText={"Student"} />)
						}
						<div className={(password.length > 0 && !isCreateLoading) ? s.btnActive : s.btnInactive} onClick={createUser}>
							{(!isCreateLoading) ? "create" : "creating..."}
						</div>
					</div>
				</div>)
			}
			
			<div className={s.paramSectionHolder}>
				<div style={{display:"flex", padding:"10px 0 0 0"}}>
					<div className={s.nonClickableTitle}>
						<span>By</span>
					</div>
					<div style={{fontWeight:"bold"}}>:</div>		
				</div>
					{
						keyData.map(
							(d, indexD) => (<>
								<div key={'ki-'+indexD} className={d.isEnable ? s.clickableOptionEnabled : s.clickableOption}
									onClick={() => {
										keyData[indexD].isEnable = !d.isEnable;
										setKeyData([...keyData]);
									}}>
									<div>{d.title}</div>
								</div>
								{(indexD != keyData.length-1) &&(<span>•</span>)}
							</>)
						)
					}
				</div>
			
			
			
			
		</div>
	
		<div style={{margin:"10px 0", fontSize:"0.8rem", gap:"10px"}}>
			{<div className={s.tableHeaderHolder}>
				<div className={s.tableHeader} style={{flex: '0 0 70px'}}>Id</div>
				<div className={s.tableHeader} style={{flex: '0 0 70px'}}>Parent Id</div>
				<div className={s.tableHeader} style={{flex: '0 0 300px'}}>Username-Nickname-Phone</div>
</div>}
			{
				users.map((d, indexD) => (<>
				
				<div key={'basic-' + indexD}
					className={s.tableRowHolder}
					style={{backgroundColor:(indexD%2==0) ? "white" : "#22222222", alignItems:"center", flexWrap:"wrap", gap:"10px"}} >
					
					<div className={s.tableRow} style={{flex: '0 0 60px'}}>
						<span className={s.spanBackground} style={{fontWeight:"bold", background:(d.id == hoverId) ? "#a3cfe6": ""}} 
							onMouseEnter={() => setHoverId(d.id)}
							onClick={()=>{
								unsecuredCopyToClipboard(d.id)
							}}
							>
								{d.id}
						</span>
					</div>
					
					<div className={s.tableRow} style={{flex: '0 0 70px'}}>
						{(d.userGroup == 4) && (<span className={s.userGroupLabel}>Parent</span>)}
						{(d.userGroup == 3) && (<span className={s.userGroupLabel} style={{color:"#52bcf7", borderColor:"#52bcf7"}}>Teacher</span>)}
						{(d.userGroup == 5) && (<span 
								className={s.spanBackground} 
								style={{background:(d.pid == hoverId) ? "#a3cfe6": ""}}
								onMouseEnter={() => setHoverId(d.pid)}>
								{d.pid}
							</span>)}
					</div>
					
					<div className={s.tableRow} style={{flex: '0 0 200px'}}
							onClick={()=>{								
								unsecuredCopyToClipboard(d.username)
							}}>
						{d.username} - {d.nickname} - {d.phone}
					</div>
					
					
					<div>
						<span className={s.btnLitActive}>
							<Link className={s.btnLitActiveLink} to={`/customer/${d.id}`} target="_blank" rel="noopener noreferrer">
								Detail
							</Link>
						</span>
					</div>
					
					<div>
						<span className={s.btnLitActive}>
							<Link className={s.btnLitActiveLink} to={`/log?id=${d.id}&limit=10`} target="_blank" rel="noopener noreferrer">
								Log
							</Link>
						</span>
					</div>
					
					<div>
						<div className={(d.accessToken) ? s.btnLitActive : s.btnLitInactive} onClick={()=>{
								enableToken(d.accessToken);
								unsecuredCopyToClipboard(d.accessToken)
							}}>
							copy AT
						</div>
					</div>
					
					{/*
					<div className={s.tableRow} style={{flex: '0 0 100px', marginTop:"5px"}}>
						
						<input value={d.nickname} style={{width:'100px'}} onChange={(e)=>{
							users[indexD].nickname = e.target.value;
							users[indexD].canUpdate = true;
							setUsers([...users])
						}} />
					</div>
					<div className={s.tableRow} style={{flex: '0 0 100px', marginTop:"5px"}}>
						<input value={d.phone} style={{width:'100px'}} onChange={(e)=>{
							users[indexD].phone = e.target.value;
							users[indexD].canUpdate = true;
							setUsers([...users])
						}} />
					</div>*/}
					
					{(addCoinsModeEnable) && (<>
					<div>Coins</div>
					<div className={s.tableRow} style={{flex: '0 0 50px', marginTop:"5px"}}>
						<input value={d.coins} style={{width:'50px'}} onChange={(e)=>{
							
							users[indexD].coins = e.target.value;
							users[indexD].canUpdate = true;
							setUsers([...users])
					
						}} />
					</div>
					<div>Expiry Date</div>
					<div className={s.tableRow} style={{flex: '0 0 200px', marginTop:"5px"}}>
						<input value={d.vipExpiryDate} 
							placeholder="yyyy-mm-dd"
							style={{width:'200px'}} onChange={(e)=>{
					
							users[indexD].vipExpiryDate = e.target.value;
							users[indexD].canUpdate = true;
							setUsers([...users])
							
						}} />
					</div>
				
					<div className={(d.canUpdate) ? s.btnLitActive : s.btnLitInactive} onClick={()=>updateUser(indexD, d.id, d.nickname, d.phone, d.email, d.coins, d.vipExpiryDate)}>
						update
					</div>
					</>)}
					
					{
						(addToEhlaOrgModeEnable && ((d.userGroup == 5 || d.userGroup == 3) && !d.oIds.includes("371"))) && (<div style={{whiteSpace: "nowrap"}} className={s.btnLitActive} onClick={()=>addUserToOrganization(indexD, d.id, 371)}>
							Add Premium
						</div>)
					}
					
					{
						((d.userGroup == 5 || d.userGroup == 3) && (d.oIds).includes("371")) && (<div className={s.is125Row}>
							Premium
						</div>)
					}
					
					
					{
						(addToEhlaOrgModeEnable && ((d.userGroup == 5 || d.userGroup == 3) && !d.oIds.includes("394"))) && (<div style={{whiteSpace: "nowrap"}} className={s.btnLitActive} onClick={()=>addUserToOrganization(indexD, d.id, 394)}>
							Add General
						</div>)
					}
					
					{
						((d.userGroup == 5 || d.userGroup == 3) && (d.oIds).includes("394")) && (<div className={s.is125Row}>
							General
						</div>)
					}
					
					
					
				</div>
				
				{
					(d.userGroup == 5) && (<div>
						{/*
						<div>Ticket</div>
						<div>{d.ticketId}</div>
						<div>{d.ticketAmt}</div>
						
						<div className={s.tableRow} style={{flex: '0 0 50px', marginTop:"5px"}}>
							<input value={d.coins} style={{width:'50px'}} onChange={(e)=>{
								
								users[indexD].coins = e.target.value;
								users[indexD].canUpdate = true;
								setUsers([...users])
						
							}} />
						</div>
				
						<div className={s.tableRow} style={{flex: '0 0 200px', marginTop:"5px"}}>
							<input value={d.ticketExpiryDate} 
								placeholder="yyyy-mm-dd"
								style={{width:'200px'}} onChange={(e)=>{
						
								users[indexD].ticketExpiryDate = e.target.value;
								users[indexD].canUpdate = true;
								setUsers([...users])
								
							}} />
						</div>
						<div className={(d.canUpdate) ? s.btnLitActive : s.btnLitInactive} onClick={()=>updateUserTicket(indexD, )}>
							update
				</div>*/}
					</div>)
				}
				
				
				</>))
			}
		
		</div></>);
	
}




const keyDefaultData = [
	{ title: 'User Id', searchKey: 'key-userId', isEnable:true},
	{ title: 'Username', searchKey: 'key-username', isEnable:true},
	{ title: 'Nickname', searchKey: 'key-nickname', isEnable:false},
	{ title: 'Phone', searchKey: 'key-phone', isEnable:false},
	{ title: 'Email', searchKey: 'key-email', isEnable:false},
]